export default __webpack_public_path__ + "static/media/email-icon.24c80f52.svg";